module.exports = __webpack_public_path__ + "img/growcify-business-owner.79d23e0d.png";